import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function EmployeeDetails({ children }) {
  useInjectSaga({ key: 'employeeDetails', saga });
  useInjectReducer({ key: 'employeeDetails', reducer });

  return React.Children.only(children);
}

EmployeeDetails.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withEmployeesDetails } from './withEmployeesDetails';
export default compose(withConnect, memo)(EmployeeDetails);
